const doc = [({"da":({"js":({"save_modes":({"save":"Gem", "save_and_close":"Gem & luk", "cancel":"Annullér"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;